<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Reformer with Tower</h2>
        <h3>Faithful Reproduction of the Original Reformer with the Space-Saving Versatility of the Tower</h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="contrology-tower3@1x.jpg"
              src2="contrology-tower3@2x.jpg"
              alt="In-use photo of Contrology Reformer with Tower"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-tower1@1x.jpg"
              src2="contrology-tower1@2x.jpg"
              alt="Photo of Contrology Reformer with Tower and accessories"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-tower2@1x.jpg"
              src2="contrology-tower2@2x.jpg"
              alt="Detail photo of Contrology Reformer with Tower and accessories"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-tower4@1x.jpg"
              src2="contrology-tower4@2x.jpg"
              alt="In-use photo of Contrology Reformer with Tower"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-tower5@1x.jpg"
              src2="contrology-tower5@2x.jpg"
              alt="In-use photo of Contrology Reformer with Tower"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-tower6@1x.jpg"
              src2="contrology-tower6@2x.jpg"
              alt="In-use photo of Contrology Reformer with Tower"
            />
          </photo-grid>

          <cta-button class="cta-button wide" />

          <div class="notice-wide">
            <p><b>Tower Retrofit Kit for Pre-Drilled Reformers</b></p>
            <p>
                If your Reformer is already pre-drilled for Tower, you can now add the Tower Retrofit Kit (current price is $2300.) To order, call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us</a>.
              </p>
              <p>
                Remember - this Tower Retrofit Kit only works on Pre-Drilled Reformers. 
              </p>
          </div>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Reformer with Tower</h2>
              <h3>Faithful Reproduction of the Original Reformer with the Space-Saving Versatility of the Tower</h3>
              <p>
                Instructors and enthusiasts are looking for more workout options in the same small area. Our Contrology® Reformer with Tower answers this demand—in the footprint of the Reformer with all the added exercises of the Tower! It’s 3 exercise stations in 1 space-saving unit: Reformer, Tower and Mat.
                <!-- <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span> -->
              </p>
              <!-- <div v-show="show">
                <p>The JGRIMES Contrology Reformer—in the words of Jay Grimes—is “everything you need and NOT all that other stuff you don’t.” It is in stock, and ships with no customization… just the way Jay likes it.</p>
                <p>If you want a different color, or padded footbar, take a look at the 80C, 86C, or 89C Contrology Apparatus.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div> -->
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="19-day lead time"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >10-Year Warranty</icon-link>
              <icon-link
                url="warranty"
                img="icon-guarantee.svg"
                alt="Guarantee icon"
                title="Learn more"
              >30-Day Money Back Guarantee</icon-link>
              <icon-link
                url="support-reformer-with-tower"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
              <modal-card
                v-if="showCardModal"
                @close="showCardModal=false"
              >
                Black only for JGRIMES Model
              </modal-card>
            </section>

            <cta-button class="cta-button" />

            <div class="notice">
              <p><b>Tower Retrofit Kit for Pre-Drilled Reformers</b></p>
              <p>
                If your Reformer is already pre-drilled for Tower, you can now add the Tower Retrofit Kit (current price is $2300.) To order, call us at 916-388-2838 or <a href="mailto:info@pilates.com">email us.</a>
              </p>
              <p>
                Remember - this Tower Retrofit Kit only works on Pre-Drilled Reformers. 
              </p>
            </div>
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <b>REFORMER</b>
            <ul class="features">
              <li>Choose from two strong, secure and durable extruded aluminum frames: 86” (218cm), 89” (226cm)</li>
              <li>4 specially-developed Contrology Reformer Springs provide the authentic “muddy” feel</li>
              <li>One-piece, weld-free side rails are stronger and easier to clean</li>
              <li>Thin, dense, resilient foam on carriage provides support, feedback and comfort</li>
              <li>Rigid shoulder supports are easy to remove and lock in place</li>
              <li>Lower angle footbar position provides increased feedback while exercising</li>
              <li>Deeper Springbar hooks provide proper spring angle</li>
              <li>Custom headrest block maintains position</li>
              <li>Contoured padded shoulder blocks for better fit</li>
              <li>Unpadded area around shoulder blocks creates space for feet to feel carriage base</li>
              <li>Pre-stretched and treated natural leather straps with O-rings and strap mounts for small adjustments in strap length</li>
            </ul>
            <b style="display: block; margin-top: 15px;">TOWER</b>
            <ul class="features">
              <li>Made of Industrial-strength “schedule 80” steel pipe</li>
              <li>Wooden Push-Through Bar (PTB)</li>
              <li>Wood Roll Back Bar 31” (80cm) with metal “s” hooks</li>
              <li>One-piece drop in Mat Conversion provides seamless support and cushioning</li>
              <li>Caster Gap Cover provides “finished” look</li>
            </ul>
            <span style="display:inline-block;margin-top:5px;">
              <em>Note: Optional Mat Dowel Handles not included.</em>
            </span>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Included" animation="reveal">
            <b>REFORMER</b>
            <ul class="included">
              <li>2 leather and wood handles</li>
              <li>36”/92cm Maple pole</li>
              <li>1 gear block</li>
              <li>2 carriage blocks</li>
              <li>2 cushioned kneeling pads</li>
              <li>Upholstered Sitting Box</li>
              <li>2 black cotton, footstraps</li>
              <li>2 black cotton, extender straps</li>
              <li>Choice of Upholstery Colors</li>
            </ul>
            <b style="display: block; margin-top: 15px;">TOWER</b>
            <ul class="included">
              <li>2 Contrology Arm Springs (light) with leather handles</li>
              <li>2 Contrology Leg Springs (light) with cotton loops</li>
              <li>2 Contrology Roll-back Bar Springs</li>
              <li>2 Contrology PTB Springs</li>
              <li>2 safety chains and 1 storage chain</li>
            </ul>
            <span style="display:inline-block;margin-top:5px;">
              <em>Note: Contrology Reformer with Tower is available as a complete system.</em>
            </span>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper bkg-fix" title="Dimensions" animation="reveal">
            <dimensions-table-ref-tow />
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <b>REFORMER</b>
              <ul class="features">
                <li>Choose from two strong, secure and durable extruded aluminum frames: 86” (218cm), 89” (226cm)</li>
                <li>4 specially-developed Contrology Reformer Springs provide the authentic “muddy” feel</li>
                <li>One-piece, weld-free side rails are stronger and easier to clean</li>
                <li>Thin, dense, resilient foam on carriage provides support, feedback and comfort</li>
                <li>Rigid shoulder supports are easy to remove and lock in place</li>
                <li>Lower angle footbar position provides increased feedback while exercising</li>
                <li>Deeper Springbar hooks provide proper spring angle</li>
                <li>Custom headrest block maintains position</li>
                <li>Contoured padded shoulder blocks for better fit</li>
                <li>Unpadded area around shoulder blocks creates space for feet to feel carriage base</li>
                <li>Pre-stretched and treated natural leather straps with O-rings and strap mounts for small adjustments in strap length</li>
              </ul>
              <b style="display: block; margin-top: 15px;">TOWER</b>
              <ul class="features">
                <li>Made of Industrial-strength “schedule 80” steel pipe</li>
                <li>Wooden Push-Through Bar (PTB)</li>
                <li>Wood Roll Back Bar 31” (80cm) with metal “s” hooks</li>
                <li>One-piece drop in Mat Conversion provides seamless support and cushioning</li>
                <li>Caster Gap Cover provides “finished” look</li>
              </ul>
              <span style="display:inline-block;margin-top:5px;">
                <em>Note: Optional Mat Dowel Handles not included.</em>
              </span>
            </tab>
            <tab name="Included">
              <b>REFORMER</b>
              <ul class="included">
                <li>2 leather and wood handles</li>
                <li>36”/92cm Maple pole</li>
                <li>1 gear block</li>
                <li>2 carriage blocks</li>
                <li>2 cushioned kneeling pads</li>
                <li>Upholstered Sitting Box</li>
                <li>2 black cotton, footstraps</li>
                <li>2 black cotton, extender straps</li>
                <li>Choice of Upholstery Colors</li>
              </ul>
              <b style="display: block; margin-top: 15px;">TOWER</b>
              <ul class="included">
                <li>2 Contrology Arm Springs (light) with leather handles</li>
                <li>2 Contrology Leg Springs (light) with cotton loops</li>
                <li>2 Contrology Roll-back Bar Springs</li>
                <li>2 Contrology PTB Springs</li>
                <li>2 safety chains and 1 storage chain</li>
              </ul>
              <span style="display:inline-block;margin-top:5px;">
                <em>Note: Contrology Reformer with Tower is available as a complete system.</em>
              </span>
            </tab>
            <tab name="Dimensions" class="table">
              <p class="cta">
                <strong>Compare Model Dimensions</strong>
              </p>
              <table>
                <thead>
                  <tr>
                    <th>Reformer</th>
                    <th>Reformer Length*</th>
                    <th>Frame Width</th>
                    <th>Frame Height</th>
                    <th>
                      Reformer
                      <br />Weight
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Contrology 86&rdquo;</td>
                    <td>87”/221cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>117lbs/53kg</td>
                  </tr>
                  <tr>
                    <td>Contrology 89&rdquo;</td>
                    <td>90”/229cm</td>
                    <td>27”/69cm</td>
                    <td>14”/36cm</td>
                    <td>118.5lbs/53.8kg</td>
                  </tr>
                </tbody>
              </table>
              <span style="display:inline-block;margin-top:5px;">
                <em>*Add 4" (11cm) to the length of the Reformer to include the addition of the Tower.</em>
              </span>
              <table>
                <thead>
                  <tr>
                    <th>Reformer</th>
                    <th>Tower Width</th>
                    <th>Tower Height</th>
                    <th>Tower Weight</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Contrology 86&rdquo;</td>
                    <td>31”/78cm</td>
                    <td>72”/183cm</td>
                    <td>37lbs/17kg</td>
                  </tr>
                  <tr>
                    <td>Contrology 89&rdquo;</td>
                    <td>31”/78cm</td>
                    <td>72”/183cm</td>
                    <td>37lbs/17kg</td>
                  </tr>
                </tbody>
              </table>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Contrology Reformer with Tower</h2>
      </section>

      <section class="carousel">
        <div class="carousel-wrapper">
          <Carousel
            :perPage="3"
            :perPageCustom="[[0,1],[375,2],[700,3]]"
            :navigationEnabled="true"
            paginationActiveColor="#ffffff"
            paginationColor="#878787"
            :paginationSize="7"
            :navigationNextLabel="nextIcon"
            :navigationPrevLabel="prevIcon"
          >
            <slide>
              <accessory-card
                url="mat-dowel-handles"
                product="Multiple Apparatus"
                src="mat-handles-2@1x.jpg"
                src2="mat-handles-2@2x.jpg"
                alt="Mat Dowel Handles product photo"
                caption="Mat Dowel Handles"
              />
            </slide>
            <slide>
              <accessory-card
                url="jpack-springs"
                product="Reformer with Tower"
                src="jpack-springs1@1x.jpg"
                src2="jpack-springs1@2x.jpg"
                alt="Jpack Springs product photo"
                caption="Jpack Springs for Tower"
              />
            </slide>
            <slide>
              <accessory-card
                url="footbar-cover"
                product="Reformer with Tower"
                src="ref-footbar1@1x.jpg"
                src2="ref-footbar1@2x.jpg"
                alt="Footbar product photo"
                caption="Footbar Cover"
              />
            </slide>
            <slide>
              <accessory-card
                url="jumpboard"
                product="Reformer with Tower"
                src="ref-jumpboard1@1x.jpg"
                src2="ref-jumpboard1@2x.jpg"
                alt="Jumpboard product photo"
                caption="Jumpboard"
              />
            </slide>
            <slide>
              <accessory-card
                url="springs"
                product="Reformer with Tower"
                src="ref-springs1@1x.jpg"
                src2="ref-springs1@2x.jpg"
                alt="Springs product photo"
                caption="Reformer Springs"
              />
            </slide>
          </Carousel>
        </div>
      </section>

      <testimonial
        src="quotebanner-tower@1x.jpg"
        src2="quotebanner-tower@2x.jpg"
        alt="Woman working out on Contrology Reformer with Tower"
        position="70%"
      >
        “Same springs, same Roll Back Bar, same Push-Through Bar, with the same location and height from the mat as on our Contrology Cadillac”.
        <span>~Ken Endelman, CEO Balanced Body</span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/6f-QFQ7n6FM?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCard from "@/components/ModalCard.vue";
import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import DimensionsTableRefTow from "@/components/DimensionsTableRefTow.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Testimonial from "@/components/Testimonial.vue";
import { Carousel, Slide } from 'vue-carousel';
import Modal from "@/components/Modal.vue";

export default {
  name: "reformer",

  metaInfo: {
    title: "Classical Pilates Contrology Reformer with Tower",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Want a Classical Pilates Reformer with a Tower? Enjoy this faithful reproduction of the Original Refomer with the space saving versatility of the tower. Shop now."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCard,
    CtaButton,
    ProdAccordion,
    DimensionsTableRefTow,
    Tabs,
    Tab,
    AccessoryCard,
    Testimonial,
    Carousel,
    Slide,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Reformer with Tower",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 41265575985345,
          partnumber: "17424",
          price: "6950",
          name: '86” Model',
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 49013849030849,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 49013849063617,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 49013849096385,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 49013849129153,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 49013849161921,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 49013849194689,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 49013849227457,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 49013849260225,
          partnumber: "17424C",
          price: "6950",
          name: '86” Model',
          color: "Wedgewood Upholstery",
          available: true
        },
        {
          prodid: 41265576018113,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Black Upholstery",
          available: false
        },
        {
          prodid: 49013849292993,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Adobe White Upholstery",
          available: false
        },
        {
          prodid: 49013849325761,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Burgundy Upholstery",
          available: false
        },
        {
          prodid: 49013849358529,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Dark Cherry Upholstery",
          available: false
        },
        {
          prodid: 49013849391297,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Greystone Upholstery",
          available: false
        },
        {
          prodid: 49013849424065,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Oak Upholstery",
          available: false
        },
        {
          prodid: 49013849456833,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Sage Upholstery",
          available: false
        },
        {
          prodid: 49013849489601,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Storm Upholstery",
          available: false
        },
        {
          prodid: 49013849522369,
          partnumber: "17424C",
          price: "6950",
          name: '89” Model',
          color: "Wedgewood Upholstery",
          available: false
        },
      ]
    };
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z" fill="black"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z" fill="black"/>
</svg>`;
    }
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

::v-deep .bkg-fix .panel {
  background-color: transparent;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

::v-deep .VueCarousel {
  max-width: 900px;
  margin: 0 auto;
}

::v-deep .VueCarousel-dot-container {
  display: block;
  margin-top: 0 !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-dot {
  margin-top: 0 !important;
  padding: 0 7px !important;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

::v-deep .VueCarousel-navigation--disabled {
  opacity: 0.3;
}

.notice {
  border: 1px solid #000000;
  padding: 0 10px;
  margin-bottom: 30px;
}

.notice-wide {
  display: none;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .table {
    max-width: 650px;
    margin: 0 auto;
  }

  .table table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .table th,
  .table td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .table td {
    height: 50px;
  }

  .table tr th:first-of-type,
  .table tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }

  .notice {
    order: 4;
    margin-bottom: 0;
    margin-top: 10px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 0 120px auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    max-width: 512px;
  }

  .cta-button, .notice {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }

  .notice-wide {
    display: block;
    border: 1px solid #000000;
    padding: 0 10px;
    margin: 0 32px;
    height: 200px;
  }
}
</style>
